import type { ReactNode } from 'react';

import type { TTestimonialsElement } from '@shared/dream-components';
import { TestimonialsElement } from '@shared/dream-components';

import useIsMobile from '~/hooks/useIsMobile';

interface Props {
  node: TTestimonialsElement;
  children: ReactNode | ReactNode[];
}

const Testimonials = ({ node, children }: Props) => {
  const isViewportMobile = useIsMobile();

  return (
    <TestimonialsElement isLive element={node} viewport={isViewportMobile ? 'mobile' : 'desktop'}>
      {children}
    </TestimonialsElement>
  );
};

export default Testimonials;
